import { ProductCardsSkeleton } from "../../../components/ProductCard"
import { ProductList } from "../../../components/ProductList"

export const ITEMS_PER_PAGE = 18

export const BundleProductsSkeleton = () => {
  return (
    <ProductList>
      <ProductCardsSkeleton count={ITEMS_PER_PAGE} />
    </ProductList>
  )
}
